import { createApp } from 'vue'

import 'bootstrap-css-only/css/bootstrap.min.css'
import '@/mdb.css'
import '@/main.css'
import '@/grid.css'

import i18n from '@/i18n'
import logger from '@/logger'
import router from '@/router'
import store from '@/store'
import { vueErrorHandler } from '@/store/plugins/errorHandler'
import security from '@/security'

import App from '@/components/layout/App.vue'
import verticalAligner from '@/components/common/VerticalAligner.vue'
import { mdbContainer, mdbRow, mdbCol } from '@/components/mdbvue'
import { AxiosError } from 'axios'

store.dispatch('fetchVersion').then(() => {
	const version = store.state.version
	console.log(JSON.parse(JSON.stringify({ version })))
}).then(() => store.dispatch('fetchUser')).then(() => {
	const app = createApp(App)
	app.use(logger)
	app.use(store)
	app.use(vueErrorHandler, { store })
	app.use(router)
	app.use(security, { router, store })
	app.use(i18n)
	app.component('mdb-container', mdbContainer)
	app.component('mdb-row', mdbRow)
	app.component('mdb-col', mdbCol)
	app.component('vertical-aligner', verticalAligner)
	app.provide('router', router)
	app.mount("#app")
}).catch(error => {
	if (error instanceof AxiosError) {
		store.commit('ADD_ERROR', error)
		return
	}
	console.error(error)
});
